<div class="bottomsheet-holder" id="iosBottomsheet">
  <div class="option-container">
    <div *ngIf="data.title" class="option-title">
      <p>{{ data.title }}</p>
    </div>
    <div
      class="option-holder"
      *ngFor="let title of data.actionButtonTitles; let i = index"
      id="button{{ i }}"
      (click)="buttonSelected(title)"
    >
      <p>{{ title }}</p>
    </div>
  </div>
  <div class="space"></div>
  <div class="cancel" (click)="dismiss()">
    <p>{{ data.dismissTitle }}</p>
  </div>
  <div class="space"></div>
</div>
